//Npm Packages
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

//Redux Actions
import {
  LOGIN,
  LOGOUT,
  USERLIST,
  USERFORM,
  APPLICATIONSETTING,
  UPDATETHEME,
  LICENSEFORM,
  LICENSELIST,
  RESETPASSWORD,
  FACILITYFORM,
  EQUIPMENTFROM,
  EQUIPMENTLIST,
  HISTORYLIST,
  PREFERENCELIST,
  PREFERENCEFORM,
  REPORTFORM,
  COMBOTYPES,
  RESETPASSWORDREQ,
  TESTACCESSLOCATION,
  MODELFORM,
  MODELLIST,
  COUNTRIES,
  TRACKING_SYSTEM_LIST,
  TRACKING_SYSTEM_FORM,
  CAT_SOFTWARE_VERSION_FORM,
  CAT_SOFTWARE_VERSION_LIST,
  SORTORDERLIST,
  SORTORDERFORM,
  TRACKING_SYSTEM_CONTACT_FORM,
  TRACKING_SYSTEM_CONTACT_LIST
} from '../actions';

//initial state for server request
const initialState = { data: {} };

//initial state for local
const localState = { isDark: false, navOpen: true };

/**
 * @desc Local state reducer (data inside this reducer will be at zero level, like: {abcd:'xyz'})
 * @param {String} actionType - Reducer action type
 */
const localStates = actionType => {
  return (state = localState, action) => {
    const { type = '', data = {} } = action;
    switch (type) {
      case actionType:
        return {
          ...state,
          ...data
        };
      default:
        return state;
    }
  };
};

/**
 * @desc Request state reducer (data inside this reducer will be at first level, like: {data: {abcd:'xyz'}})
 * @param {String} actionType - Reducer action type
 */
const returnStates = actionType => {
  return (state = initialState, action) => {
    const { type = '', data = {} } = action;
    switch (type.replace(/_SUCCESS|_FAILURE|_ERROR/g, '')) {
      case actionType:
        return {
          ...state,
          data
        };
      case `${actionType}_RESET`:
        return initialState;
      default:
        return state;
    }
  };
};

function setComboTypes(state = {}, action) {
  switch (action.type.replace(/_SUCCESS|_FAILURE|_ERROR/g, '')) {
    case COMBOTYPES:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}

export default combineReducers({
  //Local state
  settingData: localStates(APPLICATIONSETTING),
  comboTypes: setComboTypes,

  //Request states
  loginData: returnStates(LOGIN),
  logoutData: returnStates(LOGOUT),
  userListData: returnStates(USERLIST),
  userFormData: returnStates(USERFORM),
  licenseFormData: returnStates(LICENSEFORM),
  licenseListData: returnStates(LICENSELIST),
  setUpdateData: returnStates(UPDATETHEME),
  resetPasswordData: returnStates(RESETPASSWORD),
  resetPasswordReqData: returnStates(RESETPASSWORDREQ),
  facilityFormData: returnStates(FACILITYFORM),
  equipmentFormData: returnStates(EQUIPMENTFROM),
  equipmentListData: returnStates(EQUIPMENTLIST),
  historyListData: returnStates(HISTORYLIST),
  preferenceListData: returnStates(PREFERENCELIST),
  preferenceFormData: returnStates(PREFERENCEFORM),
  reportFormData: returnStates(REPORTFORM),
  testAccessLocation: returnStates(TESTACCESSLOCATION),
  modelListData: returnStates(MODELLIST),
  countriesData: returnStates(COUNTRIES),
  modelFormData: returnStates(MODELFORM),
  trackingSystemFormData: returnStates(TRACKING_SYSTEM_FORM),
  trackingSystemListData: returnStates(TRACKING_SYSTEM_LIST),
  sortOrderListData: returnStates(SORTORDERLIST),
  sortOrderFormData: returnStates(SORTORDERFORM),
  catSoftwareVersionFormData: returnStates(CAT_SOFTWARE_VERSION_FORM),
  catSoftwareVersionListData: returnStates(CAT_SOFTWARE_VERSION_LIST),
  trackingSystemContactFormData: returnStates(TRACKING_SYSTEM_CONTACT_FORM),
  trackingSystemContactListData: returnStates(TRACKING_SYSTEM_CONTACT_LIST),
  form: formReducer
});
